import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000, headers: { "Content-Type": "application/json" } });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mazboy_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("mazboy_token");
        localStorage.removeItem("mazboy_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default client;

export const WS_URL = (() => {
  if (!BACKEND_URL) return "";
  const url = new URL(BACKEND_URL);
  const proto = url.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${url.host}/api/ws`;
})();
